import React, { useState, useEffect } from "react"
// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import logoDark from "../../assets/images/logo-dark.png"
import logoLight from "../../assets/images/logo-dark.png"

import OrganizationForm from "./OrganizationForm"
// action
import { registerUser, apiError } from "../../store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import { ApiNames } from '../../components/Common/ApiManagement/apiServices';

import { Link, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Row,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap"

import "./common.scss";
import axiosInstance from "components/Common/ApiManagement/axiosInstance"
import { handleErrors, showToaster } from "components/Common/common"
import { PAGEPATHS } from "components/Common/Constant"
import GoogleLogin from "./GoogleLogin"

const Register = props => {
  document.title = "Register | Skote - React Admin & Dashboard Template"

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [suggestions, setSuggestions] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [orgInputValue, setOrgInputValue] = useState("");
  const [organizationId, setOrganizationId] = useState("");

  const [loading, setLoading] = useState(false);
  const [addOrgButton, setAddOrgButton] = useState(false);

  const [modal, setModal] = useState(false);
  const [isModifying, setIsModifying] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      firstname: "",
      lastname: "",
      // phonenumber: "",
      password: "",
      organization: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      firstname: Yup.string().required("Please Enter Your First Name"),
      lastname: Yup.string().required("Please Enter Your Last Name"),
      // phonenumber: Yup.string().required("Please Enter Phone number"),
      password: Yup.string().required("Please Enter Your Password"),
      organization: Yup.string().required("Please Enter Your Organization")
    }),
    onSubmit: values => {
      dispatch(registerUser(values))
      handleSubmit(1, values)
    },
  })

  const orgValidation = useFormik({
    enableReinitialize: true,

    initialValues: {
      branch: '',
      agency: '',
      office: undefined,
      city: undefined,
      state: undefined,
      securityContact: undefined
    },
    validationSchema: Yup.object({
      branch: Yup.string().required("Please Enter Your Branch"),
      agency: Yup.string().required("Please Enter Your Agency")
    }),
    onSubmit: values => {
      handleSubmit(2, values)
    },
  })

  const selectAccountState = state => state.Account
  const AccountProperties = createSelector(selectAccountState, account => ({
    user: account.user,
    registrationError: account.registrationError,
    success: account.success
  }))

  const { success } = useSelector(AccountProperties)

  useEffect(() => {
    dispatch(apiError(""))
  }, [dispatch])

  useEffect(() => {
    success && setTimeout(() => navigate(PAGEPATHS.Login), 2000)
  }, [success, navigate])

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  const handleSubmit = async (type, values) => {

    if (type === 1) {   
      const postForm = {
        email: values.email,
        password: values.password,
        firstname: values.firstname,
        lastname: values.lastname,
        // phoneNumber: Number(values.phonenumber),
        orgId: organizationId
      }

      try {
        const { data } = await axiosInstance.post(ApiNames.USER_SIGNUP, postForm);
        if (data.status === 1) {
          showToaster(data.status, data.message)
          navigate(PAGEPATHS.Login, { state: { email: values.email, password: values.password } });
        }
      } catch (error) {
        handleErrors(error)
      } finally {
        setLoading(false);
      }
    } else {
      try {
        setIsModifying(true)
        const { data } = await axiosInstance.post(ApiNames.ADD_ORGANIZATION, values)
        if (data.status) {
          setModal(false)
          setOrganizationId(data.data)
          showToaster(data.status, data.message)
        }
      } catch (error) {
        handleErrors(error)
      } finally {
        setIsModifying(false)
      }
    }
  };

  const fetchSuggestions = async (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }
    try {
      const { data } = await axiosInstance.get(`${ApiNames.LIST_ORGANIZATION}?search=${query}`)
      setSuggestions(data.data);
      setDropdownOpen(data.data.length > 0)
      setAddOrgButton(query.length > 2 && !data.data.length > 0)
    } catch (error) {
      handleErrors(error)
    }
  };

  const handleOrgInputChange = e => {
    validation.handleChange(e);
    const value = e.target.value;
    setOrgInputValue(value);
    fetchSuggestions(value);
  };

  const handleSelect = org => {
    setOrgInputValue(org.branch);
    setOrganizationId(org._id);
    validation.setFieldValue("organization", org.branch);
    setSuggestions([]);
    setDropdownOpen(false);
  };

  return (
    <React.Fragment>
      <div className="account-pages pt-7 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5} className='px-4'>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/" className="d-block auth-logo">
                      <img
                        src={logoDark}
                        alt=""
                        height="30"
                        className="auth-logo-dark"
                      />
                      <img
                        src={logoLight}
                        alt=""
                        height="30"
                        className="auth-logo-light"
                      />
                    </Link>
                  </h3>
                  <div className="px-0 md:px-3 p-3">
                    <h4 className="text-muted font-size-18 mb-1 text-center">
                      Register
                    </h4>
                    <Form
                      className="form-horizontal mt-4"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()

                      }}
                    >

                      <div className="mb-3">
                        <Input
                          name="firstname"
                          type="text"
                          placeholder="Enter First Name "
                          className="form-control py-2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.firstname || ""}
                          invalid={
                            validation.touched.firstname &&
                              validation.errors.firstname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.firstname &&
                          validation.errors.firstname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.firstname}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <Input
                          name="lastname"
                          type="text"
                          placeholder="Enter Last Name "
                          className="form-control py-2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.lastname || ""}
                          invalid={
                            validation.touched.lastname &&
                              validation.errors.lastname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.lastname &&
                          validation.errors.lastname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.lastname}
                          </FormFeedback>
                        ) : null}
                      </div>

                     {/*<div className="mb-3">
                        <Input
                          name="phonenumber"
                          type="text"
                          placeholder="Enter Phone number"
                          className="form-control py-2"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phonenumber || ""}
                          invalid={
                            validation.touched.phonenumber &&
                              validation.errors.phonenumber
                              ? true
                              : false
                          }
                        />
                        {validation.touched.phonenumber &&
                          validation.errors.phonenumber ? (
                          <FormFeedback type="invalid">
                            {validation.errors.phonenumber}
                          </FormFeedback>
                        ) : null}
                      </div> */} 

                      <div className="mb-3">
                        <Input
                          id="email"
                          name="email"
                          className="form-control py-2"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Input
                          name="password"
                          type="password"
                          className="form-control py-2"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                              validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                          validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                        <DropdownToggle tag="div" className="w-100">
                          <div className="mb-3 position-relative">
                            <Input
                              name="organization"
                              type="text"
                              className="form-control py-2"
                              placeholder="Choose or create organization"
                              onChange={handleOrgInputChange}
                              onBlur={validation.handleBlur}
                              value={orgInputValue || validation.values.organization || ""}
                              invalid={
                                validation.touched.organization &&
                                  validation.errors.organization
                                  ? true
                                  : false
                              }
                            />
                            {addOrgButton && (
                              <button
                                className="position-absolute btn btn-primary waves-effect waves-light"
                                style={{
                                  top: '13%',
                                  right: '1.5%',
                                  padding: '3px 10px'
                                }}
                                onClick={(e) => {
                                  e.preventDefault()
                                  setModal(true)
                                  orgValidation.values.branch = orgInputValue
                                }}
                              >
                                <i className="mdi mdi-plus fw-bold font-size-17 text-center"></i>
                              </button>
                            )}
                            {validation.touched.organization &&
                              validation.errors.organization && (
                                <FormFeedback type="invalid">
                                  {validation.errors.organization}
                                </FormFeedback>
                              )}
                          </div>
                        </DropdownToggle>
                        {suggestions.length > 0 && (
                          <DropdownMenu className="w-100">
                            {suggestions.map((org, index) => (
                              <DropdownItem key={index} onClick={() => handleSelect(org)}>
                                {org.branch}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        )}
                      </Dropdown>
                      {/* )} */}

                      <div className="row mt-4 align-items-center">
                        <div className="col-6">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Register
                          </button>
                        </div>
                        <div className="col-6 text-end">
                          <p className="mb-0">
                            Existing User ?{" "}
                            <Link to={PAGEPATHS.Login} className="">
                              {" "}
                              Login{" "}
                            </Link>{" "}
                          </p>
                        </div>
                      </div>
                    </Form>
                  </div>
                  <GoogleLogin />
                </CardBody>
              </Card>
              <Card>
                <OrganizationForm
                  modal={modal}
                  setModal={setModal}
                  isModifying={isModifying}
                  orgValidation={orgValidation}
                />
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Register
